import React, { useMemo, useCallback, useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom'
import { List, Button, WhiteSpace, Toast, Picker, InputItem } from 'antd-mobile'
import { createForm } from 'rc-form';

import { UrlSearch } from '../../../utils/utils'
import { AddAgentUser, GetAgentList } from '../../../api/order';
import { GetCompanyList } from '../../../api/usms';
import { AclKeys } from '../utils/permissions';
import Permission from '../components/Permission';

// 传递id，获取当前用户详情
function AddUser(props){

    const [companyInfo, setCompanyInfo] = useState({})
    const [loading, setLoading] = useState(true)
    const [userList, setUserList] = useState([])
    const [confirmLoading, setConfirmLoading] = useState(false)
    const [searchValue, setSearchValue] = useState('')
    
    const { getFieldProps, getFieldError } = props.form;
    const AgentId = useMemo(() => {
        return UrlSearch("AgentId")
    }, []);

    const DomainList = useMemo(() => {
        return ((companyInfo && companyInfo.Domain) || []).map(item => ({
            value: item,
            label: item
        }))
    }, [companyInfo])

    const errors = {
        CompanyId: getFieldError('CompanyId')
    }

    if(!AgentId){
        props.history.push(`/usms/agentlist`)
    }

    const handleSearch = useCallback((value) => {
        setSearchValue(value)
    }, [])

    const filterUserList = useMemo(() => {
        return userList.filter(item => {
            if(searchValue){
                return (item.label).toLowerCase().indexOf(searchValue.toLowerCase()) > -1
            }else{
                return true
            }
        })
    }, [userList, searchValue])

    // 获取代理商详情
    const getDetail = useCallback((data) => {
        setLoading(true)
        GetAgentList(data).then(res => {
            const { Data } = res;
            if(Data && Array.isArray(Data) && Data.length){
                setCompanyInfo(Data[0])
            }
            setLoading(false)
        }).catch(() => {
            setLoading(false)
        })
    }, [])

    // 获取可以选择用户列表
    const getList = useCallback((data) => {
        setLoading(true);
        GetCompanyList(data).then(res => {
            const { Data, Message } = res;
            if (Data && Data.length) {
                const result = Data.filter(s => {
                    if(s.UserStatus !== 1 || s.UserType === 4 || s.Upgrade !== 1){
                        return false
                    }
                    return true
                }).map(item => {
                    return {
                        value: item.CompanyId,
                        label: `${item.CompanyId}-${item.DisplayName}-${item.Email}`
                    }
                })
                setUserList(result)
            } else {
                Toast.fail(Message, 3);
            }
            setLoading(false);
        }).catch(e => {
            Toast.fail(e.message, 3);
            setLoading(false);
        });
    }, [])

    const onCancel = () => {
        props.history.push(`/usms/agentlist`)
    }

    // 确认添加用户
    const onConfirm = () => {
        props.form.validateFields((error, value) => {
           if(!error){
            const { CompanyId, Domain } = value
            setConfirmLoading(true)
            AddAgentUser({
                CompanyId: CompanyId[0],
                AgentId: Number(AgentId),
                Domain: Domain[0]
            }).then(res => {
                if(res.RetCode === 0){
                    Toast.success('添加成功', 3)
                }else{
                    Toast.fail(res.Message, 3);
                }
                setConfirmLoading(false)
            }).catch(err => {
                setConfirmLoading(false)
            })
           }
        });
    }

    useEffect(() => {
        getDetail({Id: Number(AgentId)})
        getList()
    }, [getDetail, getList])

    return <>
        <Permission aclKey={AclKeys.AllUserManage}>
            {loading ? <div>
                loading...
            </div>:<div className="container">
                <Permission aclKey={AclKeys.SMSAmonut}>
                    <h3 style={{paddingLeft: '10px', paddingBottom: '5px'}}>关联用户</h3>
                    <div style={{paddingLeft: '10px'}}>当前代理商：{`${companyInfo.AgentName}`}</div>
                    <List>
                        <Picker 
                            style={{overflow: 'hidden'}}
                            data={filterUserList} 
                            cols={1}
                            title={
                                <InputItem
                                    value={searchValue}
                                    onChange={handleSearch}
                                    clear
                                    placeholder="用户名搜索"
                              ></InputItem>
                            } 
                            {...getFieldProps('CompanyId', {
                                initialValue: undefined,
                                rules: [{
                                    required: true,
                                    message: '请选择用户' 
                                }]
                            })} 
                        >
                            <List.Item arrow="horizontal">选择用户</List.Item>
                        </Picker>
                        <p style={{color: 'red', paddingLeft: '16px'}}>{ errors.CompanyId ? errors.CompanyId.join(',') : null}</p>
                        <Picker 
                            data={DomainList} 
                            cols={1} 
                            {...getFieldProps('Domain', {
                                initialValue: '',
                                rules: [{
                                    required: false,
                                    message: '请选择关联的域名' 
                                }]
                            })} 
                        >
                            <List.Item arrow="horizontal">选择关联的域名</List.Item>
                        </Picker>
                    </List>
                    <WhiteSpace />
                    <WhiteSpace />
                    <WhiteSpace />
                    <Button loading={confirmLoading} onClick={onConfirm} type="primary">确定</Button><WhiteSpace />
                    <Button onClick={onCancel}>返回</Button><WhiteSpace />
                    </Permission>
            </div>}
        </Permission>
    </>
}
export default createForm()(withRouter(AddUser))